import { EditorContent, useEditor } from '@tiptap/react';
import React from 'react';

import Link from '@tiptap/extension-link';
import StarterKit from '@tiptap/starter-kit';
import clsx from 'clsx';
import { Markdown } from 'tiptap-markdown';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';

import { makeStyles, blend } from '@gogame/ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '14px',
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    borderTop: ({ editable }) => {
      return editable ? `1px solid ${theme.palette.divider}` : 'none';
    },
    display: 'flex',
    width: '100%',
    flexGrow: 1,
    userSelect: 'text',
    '& table': {
      borderCollapse: 'collapse',
      background: `${theme.palette.background.hover}`,
      width: '100%',
      paddingLeft: 12,
      '& tr:first-of-type': {
        background: `${blend(
          theme.palette.background.default,
          theme.palette.action.active,
          theme.palette.action.selectedOpacity
        )}`,
      },

      '& td': {
        border: `1px solid ${theme.palette.divider}`,
        padding: '8px',
        textAlign: 'left',
      },
      '& th': {
        border: `1px solid ${theme.palette.divider}`,
        padding: '8px',
        textAlign: 'left',
      },
    },
    '& blockquote': {
      borderLeft: '3px solid rgba(13,13,13,.1)',
      paddingLeft: 12,
    },
    '& strong': {
      fontWeight: 500,
    },
    '& a': {
      color: `${theme.palette.primary.main}`,
      textDecoration: 'none',
    },
    '& ul, ol': {
      margin: '8px 0',
    },
  },
  editor: {
    width: '100%',
  },
}));

export const MarkdownRender = ({ value }) => {
  const classes = useStyles({
    editable: false,
  });

  const editor = useEditor({
    extensions: [
      StarterKit,
      Link,
      Markdown,
      Table.configure({
        resizable: true,
        openOnClick: true,
        linkOnPaste: true,
      }),
      TableRow,
      TableHeader,
      TableCell,
    ],
    editable: false,
    content: value,
  });

  return (
    <div className={clsx(classes.root)}>
      <EditorContent editor={editor} className={classes.editor} />
    </div>
  );
};
